// Quatre chiffres sous le haut de page.
import React from "react";

const CHIFFRES = [
	{ valeur: "5/5", legende: "sur l'App Store et Google Play" },
	{ valeur: "20 000+", legende: "performances enregistrées" },
	{ valeur: "30 jours", legende: "d'essai sur GymNote+ et GymNote\u00a0Pro" },
	{ valeur: "100 %", legende: "utilisable hors ligne" },
];

export default function BandeConfiance() {
	return (
		<section className="gs-confiance" aria-label="GymNote en chiffres">
			<div className="gs-conteneur gs-confiance-grille">
				{CHIFFRES.map((c) => (
					<div key={c.valeur} className="gs-confiance-item">
						<span className="gs-confiance-chiffre">{c.valeur}</span>
						<span className="gs-confiance-legende">{c.legende}</span>
					</div>
				))}
			</div>
		</section>
	);
}
